import styled from 'styled-components';
import { Flex } from '../flex';
import { theme } from '../theme';

export const TextareaWrapper = styled(Flex)`
  width: 100%;
`;

export const StyledTextarea = styled.textarea<{
  hasError?: boolean;
}>`
  color: ${theme.colors.primaryK10};
  border: 1px solid ${theme.colors.primaryK4};
  padding: 0.5rem;
  width: 100%;
  transition: all 0.15s linear;

  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  word-spacing: var(--word-spacing);

  &::placeholder {
    color: ${theme.colors.primaryK7};
  }

  &:focus {
    outline: none;
  }

  &:hover,
  &:active,
  &:focus {
    border: 1px solid ${theme.colors.primaryK10};
  }

  ${(props) =>
    props.hasError
      ? `
      &, &:hover, &:active, &:focus { 
        border: 2px solid ${theme.colors.primaryR5}; 
      }`
      : ''};
`;

export const StyledTextareaWithLabel = styled(Flex)`
  margin-bottom: 1.563rem;
  width: 100%;
`;

export const TextareaLabel = styled.label`
  color: ${({theme}) => theme.colors.primaryK10};
  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  margin-bottom: 0.125rem;
  user-select: none;
`;

export const TextareaError = styled.div<{
  hasError?: boolean;
}>`
  width: 100%;
  & > p {
    background-color: ${theme.colors.primaryR5};
    color: ${theme.colors.primaryW};
    padding: 0.563rem 0.625rem;
    user-select: none;

    font-weight: ${theme.fontWeight.thin};
    font-size: var(--main-font-size);
    line-height: var(--main-line-height);
    margin: 0;
  }
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: all 0.15s linear;

  ${(props) =>
    props.hasError ? `opacity:1; visibility: visible; height: 100%;` : ''};
`;
